import { render } from "./SocialsAndBooking.vue?vue&type=template&id=6275bad8&scoped=true"
import script from "./SocialsAndBooking.ts?vue&type=script&lang=js"
export * from "./SocialsAndBooking.ts?vue&type=script&lang=js"

import "./SocialsAndBooking.vue?vue&type=style&index=0&id=6275bad8&lang=scss&scoped=true"

import exportComponent from "/Users/lucatescari/Documents/Projects/Private/rt-songpage/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6275bad8"]])

export default __exports__